export default __webpack_public_path__ + "images/PC.9d3475a.png";